import { render, staticRenderFns } from "./PlannedActivity.vue?vue&type=template&id=620ca475&scoped=true&"
import script from "./PlannedActivity.vue?vue&type=script&lang=js&"
export * from "./PlannedActivity.vue?vue&type=script&lang=js&"
import style0 from "./PlannedActivity.vue?vue&type=style&index=0&id=620ca475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ca475",
  null
  
)

export default component.exports